// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../../shared/components/editable-field/index';
import FormattedNumberInputWithErrors from '../../../../../shared/components/format-number-input-with-errors';
import KeyValueDropDown from '../key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledFormInput from '../../../../../shared/components/labeled-form-input';
import {buildNumber} from '../../../../../shared/services/build-number';
import {getFieldClassName} from '../../../services/claim-shared-helper';

function handleOptionChange(event) {

    this.onOptionChange(event.target.value);

}

function handleOptionBlur(event) {

    this.onOptionBlur(event.target.value);

}

function handleInputBlur(amount) {

    this.onInputBlur(amount);

}

function handleAmountChange(amount) {

    this.onInputChange(amount);

}

const AmountOfUseField = props => (
    <LabeledFormInput
        className={getFieldClassName(props.className, props.isValid, props.highlightClass)}
        label={props.label}
    >
        <EditableField
            className='amount'
            isEditable={props.isEditable}
            value={props.value ? buildNumber(parseFloat(props.value), {minimumFractionDigits: props.decimalPrecision}) : props.value}
        >

            <FormattedNumberInputWithErrors
                allowNegative={false}
                decimalPrecision={props.decimalPrecision}
                errorMessage={props.errorMessage}
                isValid={props.isValid}
                isValidInput={props.isValidInput}
                onBlur={props::handleInputBlur}
                onValueChange={props::handleAmountChange}
                value={props.value}
                vsrMessage={props.vsrMessage}
            />

        </EditableField>
        <EditableField
            isEditable={props.isEditable}
            value={props.selectedUnit.value}
        >
            <KeyValueDropDown
                className='unit'
                list={props.allowedUnits}
                onBlur={props::handleOptionBlur}
                onChange={props::handleOptionChange}
                showBlankOption={props.showBlankOption}
                tabIndex={props.dropdownTabIndex}
                value={props.selectedUnit.key}
            />
        </EditableField>
    </LabeledFormInput>
    );

AmountOfUseField.displayName = 'AmountOfUseField';
AmountOfUseField.propTypes = {
    allowedUnits: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    className: PropTypes.string,
    decimalPrecision: PropTypes.number,
    dropdownTabIndex: PropTypes.string,
    errorMessage: PropTypes.string,
    highlightClass: PropTypes.string,
    inputTabIndex: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    isValidInput: PropTypes.func,
    label: PropTypes.string,
    onInputBlur: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onOptionBlur: PropTypes.func,
    onOptionChange: PropTypes.func.isRequired,
    selectedUnit: PropTypes.instanceOf(KeyValuePair).isRequired,
    showBlankOption: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    vsrMessage: PropTypes.string
};
AmountOfUseField.defaultProps = {
    decimalPrecision: 0,
    errorMessage: 'AMOUNT_OF_USE_IS_REQUIRED',
    isValidInput: value => value < 1000000,
    label: 'AMOUNT_OF_USE'
};
export default AmountOfUseField;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/amount-of-use/amount-of-use-without-compliance.js